import { render, staticRenderFns } from "./partnerList.vue?vue&type=template&id=08d4d1a1&scoped=true&"
import script from "./partnerList.vue?vue&type=script&lang=js&"
export * from "./partnerList.vue?vue&type=script&lang=js&"
import style0 from "./partnerList.vue?vue&type=style&index=0&id=08d4d1a1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d4d1a1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08d4d1a1')) {
      api.createRecord('08d4d1a1', component.options)
    } else {
      api.reload('08d4d1a1', component.options)
    }
    module.hot.accept("./partnerList.vue?vue&type=template&id=08d4d1a1&scoped=true&", function () {
      api.rerender('08d4d1a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/partner/partnerList.vue"
export default component.exports